import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5f949c02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mt-4" }
const _hoisted_2 = { class: "col-md-12 text-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "row mt-4 mb-3" }
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 0,
  class: "col-md-12 mb-4 pb-4"
}
const _hoisted_12 = { class: "signature-container mb-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Faça sua assinatura abaixo:", -1))
const _hoisted_14 = { class: "signature-canvas-wrapper" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, "Use o mouse ou toque para desenhar sua assinatura", -1))
const _hoisted_16 = {
  key: 0,
  class: "alert alert-info"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle me-1" }, null, -1))
const _hoisted_18 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle me-1" }, null, -1))
const _hoisted_20 = { class: "d-grid gap-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eraser me-1" }, null, -1))
const _hoisted_22 = ["disabled"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check me-1" }, null, -1))
const _hoisted_24 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Assinatura Confirmada:", -1))
const _hoisted_27 = { class: "signature-preview" }
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 1,
  class: "col-md-12 mb-4 pb-4"
}
const _hoisted_30 = { class: "alert alert-info" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle me-1" }, null, -1))
const _hoisted_32 = { class: "nnavbar fixed-bottom bg-body-tertiary" }
const _hoisted_33 = { class: "container-fluid justify-content-start" }

import {  onMounted, reactive, ref } from "vue";
  import { useRoute, useRouter } from 'vue-router';

  import BreadCrumb from "@/components/Common/BreadCrumb.vue";

  //servicos
  import * as service from "@/services/clienteService";

  //componentes
  import imgLogin from "@/assets/images/logoLogin.png";
import { fdataHora, corrigirImagensContrato } from "@/utils/funcoes";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AssinarContrato',
  setup(__props) {

  const route = useRoute();
  const router = useRouter();

  // Referencias para o canvas de assinatura
  const canvasRef = ref<HTMLCanvasElement>();
  const isDrawing = ref(false);
  const lastX = ref(0);
  const lastY = ref(0);

  var controle = reactive({
    contratoId: 0,
    model: {} as service.Contrato,
    assinatura: {
      dataUrl: '', // Para armazenar a assinatura como base64
      confirmada: false
    },
    status: "",
    erro: "",
  })

  onMounted(async () => {
    pesquisar();
    setupCanvas();
  })

  async function pesquisar() {

    console.log("busca contrato", controle.contratoId);
    if (route.params.contratoId) {
      controle.contratoId = parseInt(route.params.contratoId as string);
    }
  
    service.obterDados()
    .then(r=> {
      console.log(r);
      controle.model = r.contratos.find(c=> c.contratoId == controle.contratoId) as service.Contrato;
    })
    .catch(erro=> {
      controle.erro = erro;
    })
  } 
  
  function setupCanvas() {
    const canvas = canvasRef.value;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Configurar estilo da linha
    ctx.strokeStyle = '#000';
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';

    // Preencher fundo branco
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }

  // Converte a posição do ponteiro (em pixels da tela) para coordenadas do canvas,
  // já que no celular o canvas é exibido em tamanho diferente da sua resolução interna (width/height do <canvas>).
  function posicaoNoCanvas(event: MouseEvent) {
    const canvas = canvasRef.value;
    const rect = canvas?.getBoundingClientRect();
    if (!canvas || !rect) return { x: 0, y: 0 };

    const escalaX = canvas.width / rect.width;
    const escalaY = canvas.height / rect.height;

    return {
      x: (event.clientX - rect.left) * escalaX,
      y: (event.clientY - rect.top) * escalaY,
    };
  }

  // Eventos do mouse
  function startDrawing(event: MouseEvent) {
    isDrawing.value = true;
    const pos = posicaoNoCanvas(event);
    lastX.value = pos.x;
    lastY.value = pos.y;
  }

  function draw(event: MouseEvent) {
    if (!isDrawing.value || !canvasRef.value) return;

    const ctx = canvasRef.value.getContext('2d');
    if (!ctx) return;

    const pos = posicaoNoCanvas(event);

    ctx.beginPath();
    ctx.moveTo(lastX.value, lastY.value);
    ctx.lineTo(pos.x, pos.y);
    ctx.stroke();

    lastX.value = pos.x;
    lastY.value = pos.y;
  }

  function stopDrawing() {
    isDrawing.value = false;
  }

  // Eventos touch para dispositivos móveis
  function startTouchDrawing(event: TouchEvent) {
    event.preventDefault();
    const touch = event.touches[0];
    const mouseEvent = new MouseEvent('mousedown', {
      clientX: touch.clientX,
      clientY: touch.clientY
    });
    startDrawing(mouseEvent);
  }

  function touchDraw(event: TouchEvent) {
    event.preventDefault();
    const touch = event.touches[0];
    const mouseEvent = new MouseEvent('mousemove', {
      clientX: touch.clientX,
      clientY: touch.clientY
    });
    draw(mouseEvent);
  }

  function stopTouchDrawing(event: TouchEvent) {
    event.preventDefault();
    stopDrawing();
  }

  // Limpar assinatura
  function limparAssinatura() {
    const canvas = canvasRef.value;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    }
    
    controle.assinatura.dataUrl = '';
    controle.assinatura.confirmada = false;
  }

  // Confirmar assinatura
  async function confirmarAssinatura() {

    console.log("salvando assinatura...");

    const canvas = canvasRef.value;
    if (!canvas) return;

    // Verificar se há algo desenhado no canvas
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;
    let hasDrawing = false;

    // Verificar se há pixels não brancos (indicando que algo foi desenhado)
    for (let i = 0; i < data.length; i += 4) {
      if (data[i] !== 255 || data[i + 1] !== 255 || data[i + 2] !== 255) {
        hasDrawing = true;
        break;
      }
    }

    if (!hasDrawing) {
      alert('Por favor, faça sua assinatura antes de confirmar.');
      return;
    }

    // Converter canvas para base64
    controle.assinatura.dataUrl = canvas.toDataURL('image/png');
    controle.assinatura.confirmada = true;

    try {
      controle.status = "Salvando assinatura...";
      
      // Aqui você faria a chamada para salvar a assinatura
      await service.SalvarAssinaturaBase64(
        { contratoId: controle.model.contratoId, 
          arquivoBase64: controle.assinatura.dataUrl }
        );

      controle.status = "Assinatura confirmada com sucesso!";
      
      // Redirecionar ou mostrar sucesso
      setTimeout(() => {
        router.push('/cliente');
      }, 2000);
      
    } catch (error) {
      controle.erro = `Erro ao salvar assinatura: ${error}`;
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _unref(imgLogin),
          alt: "Logo",
          class: "img-fluid img-logo mb-3"
        }, null, 8, _hoisted_3)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", null, "Contrato: " + _toDisplayString(_unref(controle).model.plano?.nome), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_unref(controle).erro == '')
          ? (_openBlock(), _createElementBlock("h4", _hoisted_8, _toDisplayString(_unref(controle).status), 1))
          : _createCommentVNode("", true),
        (_unref(controle).erro != '')
          ? (_openBlock(), _createElementBlock("h4", _hoisted_9, _toDisplayString(_unref(controle).erro), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      class: "mb-4 pb-4",
      innerHTML: _unref(corrigirImagensContrato)(_unref(controle).model.texto)
    }, null, 8, _hoisted_10),
    (_unref(controle).model.dataAssinatura == null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("canvas", {
                ref_key: "canvasRef",
                ref: canvasRef,
                width: "900",
                height: "420",
                class: "signature-canvas",
                onMousedown: startDrawing,
                onMousemove: draw,
                onMouseup: stopDrawing,
                onMouseleave: stopDrawing,
                onTouchstart: startTouchDrawing,
                onTouchmove: touchDraw,
                onTouchend: stopTouchDrawing
              }, null, 544),
              _hoisted_15
            ])
          ]),
          (_unref(controle).status)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _hoisted_17,
                _createTextVNode(" " + _toDisplayString(_unref(controle).status), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(controle).erro)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _hoisted_19,
                _createTextVNode(" " + _toDisplayString(_unref(controle).erro), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              onClick: limparAssinatura
            }, [
              _hoisted_21,
              _createTextVNode(" Limpar Assinatura ")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-success",
              onClick: confirmarAssinatura,
              disabled: _unref(controle).assinatura.confirmada
            }, [
              _hoisted_23,
              _createTextVNode(" " + _toDisplayString(_unref(controle).assinatura.confirmada ? 'Assinatura Confirmada' : 'Confirmar Assinatura'), 1)
            ], 8, _hoisted_22)
          ]),
          (_unref(controle).assinatura.confirmada && _unref(controle).assinatura.dataUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _hoisted_25,
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("img", {
                    src: _unref(controle).assinatura.dataUrl,
                    alt: "Assinatura",
                    class: "img-fluid border"
                  }, null, 8, _hoisted_28)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createTextVNode(" Este contrato já foi assinado em " + _toDisplayString(_unref(fdataHora)(_unref(controle).model.dataAssinatura)) + ". ", 1)
          ])
        ])),
    _createElementVNode("nav", _hoisted_32, [
      _createElementVNode("form", _hoisted_33, [
        _createVNode(_component_RouterLink, {
          class: "btn btn-primary btn-sm me-2",
          type: "button",
          to: { name: 'PainelCliente' }
        }, {
          default: _withCtx(() => [
            _createTextVNode("Voltar")
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})